import { useNavigate } from "react-router-dom";
import { PHOTO_BOTTLE_GIRL, PHOTO_DANCEFLOOR, PHOTO_RED_DRESS_1, PHOTO_HOOKAH, PHOTO_GROUP_DUPONT } from "../lib/assets";
import { useReservationModal } from "../contexts/ReservationModalContext";

const PACKAGES = [
  { title: "Bottle Service", desc: "Curated bottle parades with sparklers, premium mixers, dedicated server.", price: "From $500", img: PHOTO_BOTTLE_GIRL },
  { title: "Birthday Package", desc: "Custom birthday sparklers, complimentary champagne toast, dedicated host.", price: "From $750", img: PHOTO_RED_DRESS_1 },
  { title: "Corporate Buyouts", desc: "Private venue access, branded experience, dedicated catering, AV.", price: "Custom Quote", img: PHOTO_GROUP_DUPONT },
  { title: "High Roller VIP", desc: "Top-tier reserved tables with extended bottle list and Premium Reserve spirits.", price: "From $1,500", img: PHOTO_HOOKAH },
];

export default function VipPage() {
  const navigate = useNavigate();
  const { open: openReservation } = useReservationModal();
  return (
    <main data-testid="vip-page" className="min-h-screen bg-white">
      <section className="relative h-[60vh] min-h-[420px] overflow-hidden bg-ink">
        <img src={PHOTO_DANCEFLOOR} className="absolute inset-0 w-full h-full object-cover kenburns" alt="VIP" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/50 to-black/90" />
        <div className="relative z-10 h-full max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16 flex flex-col justify-end pb-16">
          <span className="eyebrow mb-3">— Onyx VIP</span>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.95] max-w-4xl text-white">VIP Bottle Service &amp; <span style={{ color: "var(--onyx-gold)" }}>Private Event Venue</span> in DC.</h1>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-2 gap-12">
        {PACKAGES.map((p, i) => (
          <div key={i} data-testid={`vip-package-${i}`} className="group zoom-img relative overflow-hidden border border-black/5 bg-cream">
            <div className="aspect-[4/3] overflow-hidden">
              <img src={p.img} className="w-full h-full object-cover" alt={p.title} />
            </div>
            <div className="p-8 md:p-10 bg-white">
              <div className="flex items-baseline justify-between mb-3">
                <h3 className="font-display text-3xl md:text-4xl text-ink">{p.title}</h3>
                <span className="font-display text-xl text-gold">{p.price}</span>
              </div>
              <p className="text-muted mb-6">{p.desc}</p>
              <button onClick={() => openReservation()} className="btn-luxe btn-luxe-ghost">Inquire</button>
            </div>
          </div>
        ))}
      </section>

      <section className="border-t border-black/5 py-20 text-center bg-cream">
        <div className="max-w-2xl mx-auto px-6">
          <p className="font-display italic text-2xl md:text-3xl text-ink leading-relaxed">"Every detail considered. Every guest unforgettable."</p>
          <button onClick={() => openReservation()} className="btn-luxe btn-luxe-gold mt-10">Reserve VIP Table</button>
        </div>
      </section>
    </main>
  );
}
